import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IFile } from 'src/app/_interfaces/files/i-files';
import { IUploadedFile } from 'src/app/_interfaces/patients/i-uploaded-file';
import { showNotification } from 'src/app/helpers/show-toast';

@Component({
  selector: 'app-upload-multiple-files-modal',
  templateUrl: './upload-multiple-files-modal.component.html',
  styleUrls: ['./upload-multiple-files-modal.component.scss'],
})
export class UploadMultipleFilesModalComponent implements OnInit {
  constructor(private bsModalRef: BsModalRef, private toastr: ToastrService) {}

  public event: EventEmitter<any> = new EventEmitter();
  uploadedFile: IUploadedFile = {} as IUploadedFile;
  uploadedFiles: File[] = [];
  filesCount: number = 0;
  maxDocumentsToUpload = 10;
  @Input() filesExisted: IFile[];
  @Input() title: string;
  @Input() subtitle: string;
  @Input() isUploadable: boolean = true;
  @Output() existedFileDeleted: EventEmitter<any> = new EventEmitter();
  @Output() uploadFiles: EventEmitter<any> = new EventEmitter();
  @Input() isOkayToSubmit: boolean = true;
  @Input() isUpdate: boolean = false;
  @Input() acceptedFileTypes: string = 'image/*,.pdf';
  @Input() maxFileSize: number = null;
  @Input() isSubscriptionDocument: boolean = false;

  ngOnInit(): void {
    if (this.filesExisted) {
      this.filesCount = this.filesExisted.filter((f) => f.isEditable).length;
    }
  }

  handleModalHide() {
    this.bsModalRef.hide();
  }

  onFileUploaded(event) {
    const files = event.target.files;
    for (let i = 0; i < files?.length; i++) {
      if (this.isSubscriptionDocument) {
        let isValidFile = this.isValidSubscriptionDocument(files[i]);
        if (isValidFile) {
          this.uploadedFiles.push(files[i]);
        }
      } else {
        this.uploadedFiles.push(files[i]);
      }
    }
    this.filesCount = this.uploadedFiles.length;
    event.target.value = '';
  }

  isValidSubscriptionDocument(file: File): boolean {
    let existingFileNames = this.uploadedFiles?.map((e) => e.name);
    const filesExtensions = this.acceptedFileTypes
      .split(',')
      .map((e) => e.trim());
    const fileName = file.name.split('.');
    const fileExtension = fileName[fileName.length - 1];

    let maxDocumentsExceeded =
      this.uploadedFiles.length >= this.maxDocumentsToUpload;
    if (maxDocumentsExceeded) {
      showNotification(
        'danger',
        `You can upload a maximum of ${this.maxDocumentsToUpload} files. Only the first ${this.maxDocumentsToUpload} files were added.`,
        this.toastr
      );
      return false;
    }

    let isValidSize =
      this.maxFileSize === null ? true : file.size <= this.maxFileSize;
    if (!isValidSize) {
      showNotification(
        'danger',
        `Max file size is ${this.maxFileSize / 1024 / 1024} MB.`,
        this.toastr
      );
      return false;
    }

    let isFileNameExist = existingFileNames.find((e) => e == file.name);
    if (isFileNameExist) {
      showNotification(
        'danger',
        `File ${file.name} is already added.`,
        this.toastr
      );
      return false;
    }

    let isValidExtension = filesExtensions.includes(
      `.${fileExtension.toLowerCase()}`
    );
    if (!isValidExtension) {
      showNotification(
        'danger',
        `File format is not supported. Only JPG, JPEG, PNG, GIF and PDF formats are allowed.`,
        this.toastr
      );
      return false;
    }

    return !isFileNameExist && !maxDocumentsExceeded && isValidExtension;
  }

  onDeleteFile(index) {
    this.filesCount--;
    this.uploadedFiles.splice(index, 1);
  }

  onDeleteExistedFile(file, index) {
    this.filesExisted.splice(index, 1);
    this.filesCount--;
    this.existedFileDeleted.emit({ action: 'deleteFile', file });
    this.event.emit({ action: 'deleteFile', file });
  }

  onUploadFiles() {
    this.uploadFiles.emit({
      action: 'uploadFiles',
      filesToUpload: this.uploadedFiles,
    });
    this.event.emit({
      action: 'uploadFiles',
      filesToUpload: this.uploadedFiles,
    });
    this.handleModalHide();
  }
}
